import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  combineJourneyElementCommons,
  combineJourneys,
  createBaggage,
  createJourney,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  addedBaggageTemplate,
  defaultBoardingPassResult,
  defaultCheckInBaggagePolicies,
  journeys,
  paymentRecords,
  seatmap,
  servicesToPayForOnePax,
} from '../../mock/data';
import {
  authorization,
} from '../../mock/dictionaries';
import {
  ServiceCatalog,
  servicesResponseBoardingforOnepax,
} from './common/services';

const waitlistJourney = createJourney({
  template: {
    ...journeys,
    journeyElements: combineJourneyElementCommons([
      createJourneyElementCommon({
        template: {
          ...journeys[0].journeyElements[0],
          journeyElement: createJourneyElement({
            template: {
              ...journeys[0].journeyElements[0].journeyElement,
              checkInStatus: 'standBy'
            }
          })
        }
      })
    ]).items
  }
});

/**
 * OW 1Journey
 * 1ADT
 * Stand By Checkin
 */
export const ow1Journey1AdtWaitlistRetrieve: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(servicesToPayForOnePax),
    createMockData(servicesToPayForOnePax),
    createMockData(servicesToPayForOnePax),
    createMockData(servicesToPayForOnePax)
  ],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(waitlistJourney, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse(combineJourneys([waitlistJourney]).items, 201)],
  retrieveJourney: [
    createMockData(waitlistJourney)],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    })
  ])],
  servicesCatalogueFromJourney: [createMockData(ServiceCatalog)
  ],
  addJourneyServices: [createMockDataWithResponse(servicesResponseBoardingforOnepax, 201)],
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)]
};
